import { Outlet } from "react-router-dom";
export const Reports = () => {
    return (
        <Outlet />
    )
}